import Header from "../../Components/Header"
import React from 'react'
import Metrology1 from "../../imagens/metrology/metrology.png"
import Metrology2 from "../../imagens/metrology/metrology2.png"
import Metrology3 from "../../imagens/metrology/metrology3.png"
import Metrology4 from "../../imagens/metrology/metrology4.png"
import Metrology5 from "../../imagens/metrology/metrology5.png"
import Metrology6 from "../../imagens/metrology/metrology6.png"
import Metrology7 from "../../imagens/metrology/metrology7.png"
import Metrology8 from "../../imagens/metrology/metrology8.png"
import Metrology10 from "../../imagens/metrology/metrology10.JPG"
import Metrology11 from "../../imagens/metrology/metrology11.JPG"
import Metrology13 from "../../imagens/metrology/metrology13.JPG"
import Metrology14 from "../../imagens/metrology/metrology14.JPG"
import Metrology15 from "../../imagens/metrology/metrology15.JPG"
import Metrology16 from "../../imagens/metrology/metrology16.JPG"
import Metrology17 from "../../imagens/metrology/metrology17.JPG"
import Metrology from "../../Components/metrology"




const listaMetrology = [
    {
        img: Metrology1
    },
    {
        img: Metrology2
    },
    {
        img: Metrology3
    },
    {
        img: Metrology4
    },
    {
        img: Metrology5
    },
    {
        img: Metrology6
    },
    {
        img: Metrology7
    },
    {
        img: Metrology8
    },
    {
        img: Metrology10
    },
    {
        img: Metrology11
    },

    {
        img: Metrology13
    },
    {
        img: Metrology14
    },
    {
        img: Metrology15
    },
    {
        img: Metrology16
    },
    {
        img: Metrology17
    },


]

function MetrologyCapabilitiesPage() {
    return (
        <div>
            <Header></Header>

            <Metrology
                listaMetrology={listaMetrology}
            />
        </div>
    )
}

export default MetrologyCapabilitiesPage